import "./Vehicles.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { setShowAlert } from "../slices/alertSlice";

import VehiclesHeader from "./components/VehiclesHeader/VehiclesHeader";
import VehiclesContent from "./components/VehiclesContent/VehiclesContent";

const Vehicles = () => {


    return (
        <div className={"vehicles"}>
            <div className={"vehicles_container"}>
                <div className={"vehicles_header"}>
                    <VehiclesHeader/>
                </div>
                <div className={"vehicles_content"}>
                    <VehiclesContent/>
                </div>
            </div>
        </div>
    )
}

export default Vehicles;